function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationOctagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 9.293A1 1 0 0 1 12.707 9h5.586a1 1 0 0 1 .707.293L22.707 13a1 1 0 0 1 .293.707v5.586a1 1 0 0 1-.293.707L19 23.707a1 1 0 0 1-.707.293h-5.586a1 1 0 0 1-.707-.293L8.293 20A1 1 0 0 1 8 19.293v-5.586A1 1 0 0 1 8.293 13L12 9.293zm6.293.707h-5.586L9 13.707v5.586L12.707 23h5.586L22 19.293v-5.586L18.293 10zM15 18v-5.5h1V18h-1zm0 2.5v-1.25h1v1.25h-1z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationOctagon);
export default __webpack_public_path__ + "static/media/exclamation-octagon.63dbb119f2e9c786315240497d65e988.svg";
export { ForwardRef as ReactComponent };